import {Layout} from '@components/layout/index';
import {JobListingsAll} from '@components/jobs/job-listings-all.jsx';
import {
  attachJobPostingTemplatesToListings,
  getLiveJobListings
} from '@helpers/jobs/jobs-helpers.mjs';
import {fixPropsForJson} from '@helpers/common/json.mjs';
import {DesktopMaxWidth} from '@components/widgets/Common';

export async function getServerSideProps(context) {
  // console.dir({getServerSideProps_context: context}, {depth: null});
  let jobs = await getLiveJobListings();
  jobs = await attachJobPostingTemplatesToListings(jobs);

  return {
    props: {
      jobs: fixPropsForJson(jobs),
      bgColorClass: 'bg-gray-200',
      bgColorClassMobile: 'bg-gray-50',
      paddingX: 'px-0', showPreHeader: true,
      showFooterSignup: false,
      showNav: true,
      showCartIcon: false,
      showCountdownTimer: false,
      showCountdownTimerMobile: false
    }
  };
}

export default function Jobs({jobs}) {
  return (<div className="bg-white">
      <DesktopMaxWidth>
        <JobListingsAll jobs={jobs} />
      </DesktopMaxWidth>
    </div>
  );
}

Jobs.Layout = Layout;
